import api from "../services/api";
import { endpoints } from "../services/endpoints";

export function padlockStatusLabel(status) {
  if (status === "ACTIVE") return "Activo";
  if (status === "INACTIVE") return "Inactivo";
  return status ?? "—";
}

export function padlockStatusClass(status) {
  if (status === "ACTIVE") return "text-green-600";
  if (status === "INACTIVE") return "text-red-600";
  return "text-gray-600";
}

export async function resolveBySerial(serialNumber) {
  const r = await api.get(endpoints.padlock.list);
  const arr = r.data?.data ?? r.data ?? [];
  const wanted = String(serialNumber ?? "").trim();
  const found = Array.isArray(arr)
    ? arr.find((x) => String(x?.serialNumber ?? "").trim() === wanted)
    : null;
  return found || null;
}

export async function getPermissionsWithUsers(padlockId) {
  const res = await api.get(endpoints.padlock.byId(padlockId));
  const payload = res.data?.data ?? res.data ?? {};
  let perms = Array.isArray(payload?.permissions) ? payload.permissions : [];

  const missingUser = perms.some((p) => !p.user);
  if (missingUser) {
    const uRes = await api.get(endpoints.users.list);
    const rawUsers = Array.isArray(uRes.data) ? uRes.data : (uRes.data?.data ?? []);
    const byId = new Map(rawUsers.map((u) => [u.id, u]));
    perms = perms.map((p) => (p.user ? p : { ...p, user: byId.get(p.userId) || null }));
  }

  return perms;
}
